import gql from 'graphql-tag';

import type { BriefStatus, BriefType } from 'src/data/brief';
import { executeGqlQuery } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

import { BRIEF_FROM_LIST_FRAGMENT } from './schema';

const QUERY = gql`
  query BriefStatus($id: ID!) {
    brief(id: $id) {
      ...BriefFromList
    }
  }
  ${BRIEF_FROM_LIST_FRAGMENT}
`;

interface ResultItem {
  id: ID;
  type: BriefType;
  status: BriefStatus;
  errors?: string; // JSON
}

export const queryBriefStatus = async (id: ID): Promise<ResultItem | undefined> => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables: {
      id,
    },
  });

  return getSingleProp<ResultItem>(result.data);
};
